// extracted by mini-css-extract-plugin
export default {"detailsForm":"CuuZuRf_LZnpxbJKpTtQ"};